import { Page } from '@hooks/customHooks/useAppLocation';
import { EntityType } from '@shared/types/entityType';
import { UserRole } from 'services/ClaimscoreApiService/shared/types';
import {
  CheckPagePermissionParams,
  PermissionChecker,
  PermissionsContext,
} from './types';

const pagePermissions = new Map<Page, PermissionChecker>([
  [Page.dashboard, () => true],
  [
    Page.permissions,
    ({ urlPathname, has }) => {
      if (urlPathname?.includes('history')) {
        return has(EntityType.Organization, UserRole.Owner, UserRole.Admin);
      }
      return (
        has(EntityType.Organization, UserRole.Owner, UserRole.Admin) ||
        has(EntityType.Case, UserRole.Owner, UserRole.Admin)
      );
    },
  ],
  [
    Page.scheduledReports,
    ({ has }) => has(EntityType.Case, UserRole.Owner, UserRole.Admin),
  ],
  [
    Page.files,
    ({ has }) => has(EntityType.Case, UserRole.Owner, UserRole.Admin),
  ],
  [
    Page.caseSettings,
    ({ has }) => has(EntityType.Case, UserRole.Owner, UserRole.Admin),
  ],
  [
    Page.developerTools,
    ({ has }) =>
      has(
        EntityType.Organization,
        UserRole.Owner,
        UserRole.Admin,
        UserRole.Developer,
      ),
  ],
  [Page.security, () => true],
]);

export function checkPagePermission({
  page = Page.dashboard,
  urlPathname = [],
  orgRole,
  caseRole,
}: PermissionsContext): boolean {
  const pagePermissionCheck = pagePermissions.get(page);

  const pageAccessContext: CheckPagePermissionParams = {
    page,
    urlPathname,
    role: { org: orgRole, case: caseRole },
    has: (scope, ...allowed) => {
      const accessRole = scope === EntityType.Organization ? orgRole : caseRole;
      return accessRole ? allowed.includes(accessRole) : false;
    },
  };

  return pagePermissionCheck ? pagePermissionCheck(pageAccessContext) : false;
}
